module.exports = __webpack_public_path__ + "media/images/pc/specials/fair_event/gallery/tmb_gallery2-6673b10d528fbff3f5eeb2fb23d1b918.jpg";